@if (order$ | async; as order) {
  <app-custom-order-confirmation-overview [order]="order"></app-custom-order-confirmation-overview>
}
